export enum ValidRPCProvidersEnum {
  DEFAULT,
  CUSTOM,
  INFURA,
  ALCHEMY,
}
